import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AcademicsService} from "./academics.service";
import {Offcanvas} from "../form.offcanvas";
import {Router} from '@angular/router';
import {FormValidator} from "../form.validator";
import {ScriptLoader} from "../script-loader";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { BrandService } from '../brand/brand.service';

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;
declare var materialadmin: any;

@Component({
  selector: 'app-academics',
  templateUrl: './academics.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/wizard/wizard.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './academics.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [AcademicsService,Offcanvas,FormValidator,ScriptLoader]
})

export class AcademicsComponent implements OnInit {
    private langChangeSubscription: any;

  academicList = [];
  classStandards = [];
  classSections = [];
  students = [];
  nextClassOfClass = [];
  studentPromotionList = [];
  loaded = false;
  selectedAcademic: any; //= {pkAcademicId:null,totalStudents:0,promotedStudents:0,newStudents:0};
  createFinancialTerm = {termName:null,startDate:'',endDate:''};
  selectedFinancialTerm = {pkFinancialTermId:null,TermName:null,StartDate:null,EndDate:null};
  studentDataTable = null;
  academicsListTable = null;
  currentAcademic: any; //= {pkAcademicId:''};
  nextAcademic = null;
  studentPromotionListTable = null;
  fromPromoteStudent = false;
  statusMessage = "Please wait academic transition is in progress";
  generatePromotionListMessage = "Please wait we are generating student promotion list for review";
  academicTransitionResults = {Year:".......",totalClasses:".......",totalStaff:"......",totalStudents:"......"};
  academicPermissions = {ADD_NEW_ACADEMIC:"DISABLED",PROMOTE_STUDENT:"DISABLED",FINANCIAL_TERMS_FEE_OVERVIEW:"DISABLED"};
  fetchingFinancialTerms = false;
  financialTermsList = [];
  includeLateFeeInTransport = true;
  financialTermProcessing = false;
  updatingAcademicYear = false;
    transportApplyLateFeesAcademicId : any;
  transportApplyLateFeesStatus: boolean;
  brand = this.brandService.brand;
  constructor(private router: Router, private academicService: AcademicsService,
    private offcanvas: Offcanvas,private formValidator : FormValidator,
    private scriptLoader:ScriptLoader, private translate: TranslateService,private messageService : MessageService,
    private brandService: BrandService) {

  }

  setTranslatedDefaults(): void {
    this.translate.get([
      'pleaseWaitAcademicTransitionIsInProgress',
      'pleaseWaitWeAreGeneratingStudentPromotionListForReview'
    ]).subscribe(translations => {
      this.statusMessage = translations['pleaseWaitAcademicTransitionIsInProgress'];
      this.generatePromotionListMessage = translations['pleaseWaitWeAreGeneratingStudentPromotionListForReview'];
    });

  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  goOut(ac) {
    this.offcanvas.handleOffcanvasOpen("#offcanvas-view-academics");

    this.selectedAcademic = ac;
    this.getClassStandardsOfSchool();
    this.applyDataTable();
    if(this.studentDataTable != null){
      this.studentDataTable.clear().draw();
    }
  }

  fetchSections() {
    var id = $("#selectStandard").val();
    if (id != '') {
      $("#viewStudentsButton").removeClass("disabled");
      this.getClassSections(id);
    }
    else {
      $("#viewStudentsButton").addClass("disabled");
    }
  }

  viewStudents() {
    var selectStandard = $("#selectStandard").val();
    var selectSection = $("#selectSection").val();
    var selectStatus = $("#selectStatus").val();
    if (selectStandard != '' || selectSection != '') {
      this.getStudents(selectStandard, selectSection, selectStatus, this.selectedAcademic.pkAcademicId);
    }

  }
  initScripts() {
    this.scriptLoader.loadScript($, 'ACADEMICS');
  }
  loginMode = "";
  ngOnInit() {
    this.setTranslatedDefaults();
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setTranslatedDefaults();
            this.studentDataTable = null;
      this.destroyDataTable('academics_list_table');
        this.destroyDataTable('datatableSlideStudents');
      this.applyDataTable();
      this.applyAcademicListTable();  
      this.getAcademicList();
    });
    this.initScripts()
    this.loginMode = localStorage.getItem('loginMode');
   if(this.loginMode == "STAFF"){
      this.router.navigate(['/exams']);
    }
    var adminPermissionlist = localStorage.getItem('adminPermissionlist');
    if(adminPermissionlist){
      var list = JSON.parse(adminPermissionlist);
      this.academicPermissions.ADD_NEW_ACADEMIC = list.ADD_NEW_ACADEMIC;
      this.academicPermissions.PROMOTE_STUDENT = list.PROMOTE_STUDENT;
      this.academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW = list.FINANCIAL_TERMS_FEE_OVERVIEW;
    }

    $("#viewStudentsButton").addClass("disabled");
    setTimeout(() =>{
      this.getAcademicList();
    },500)
    
    $(document).ready(function(){
      $('.viewstudent').attr('href','#offcanvas-view-student-feedetails2');
    });
  }

   destroyDataTable(table) {
    $('#' + table).DataTable().destroy();
  }
  getAcademicList() {
    this.academicList = []
    if ($.fn.DataTable.isDataTable("#academics_list_table")) {
      $("#academics_list_table").DataTable().clear().destroy();
    }
    this.academicService.fetchAcademicList()
      .subscribe(
        // (data: any) => this.schoolMatrices  = data,
        (data: any) => {

          if (data.errorcode) {

          }
          else {
            this.academicList = JSON.parse(JSON.stringify(data.academicList));
            if (this.academicList.length == 0) {
              $(".dataTables_empty").removeClass('hidden');
            } else {
              $(".dataTables_empty").addClass('hidden');
            }

            this.academicList.forEach(function (item) {
              item.current = false;
              item.notstarted = false;
              item.completed = false;
              if (item.InActive == 0) {
                item.current = true;
                $("#currentAcYear").text(item.Year)
                $("#currentAcStudents").text(item.totalStudents)
                $("#currentAcPromotedStudents").text(item.promotedStudents)
                $("#currentAcNewStudents").text(item.newStudents)
              }
              else if (item.InActive == 1) {
                var sDate = new Date(item.StartDate);
                var eDate = new Date(item.EndDate);
                if (eDate < new Date()) {
                  item.completed = true;
                }
                else {
                  item.notstarted = true;
                }
              }
            })
          }
          if(!this.loaded){
            this.loaded = true;

          
            setTimeout(() =>{
              this.applyAcademicListTable();
            },100)
          }
          else{
            this.applyAcademicListTable();
          }
        },
        error =>
        () => {
        }
      );
  }

  openFinancialTerms(academic){
    this.financialTermsList = [];
    this.selectedAcademic = academic;
    this.fetchingFinancialTerms = true;
    this.academicService.getFinancialTerms(academic.pkAcademicId).subscribe(
      (data: any) => {
        this.financialTermsList = data;
        this.fetchingFinancialTerms = false;
      },
      async error => {
        const unableFinancialTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('unableFinancialTermPleaseTryAgain')); 
        customToastr(unableFinancialTermPleaseTryAgainTranslation, 'error');
      }
    );
  }

  async createFinancialTermFun(termDetails){
    let stDate = $("#duedateDatePicker1").val();
    let edDate = $("#duedateDatePicker2").val();

    if(this.formValidator.validateIsData(stDate) && this.formValidator.validateIsData(edDate) && this.formValidator.validateIsData(termDetails.termName)){
      let _stDate = stDate.split('/');
      stDate = _stDate[2]+"-"+_stDate[1]+"-"+_stDate[0];

      let _edDate = edDate.split('/');
      edDate = _edDate[2]+"-"+_edDate[1]+"-"+_edDate[0];

      let d1 = new Date(stDate);
      let d2 = new Date(edDate);
      if(d1 >= d2){
        const pleaseSelectValidDatesTranslation = await firstValueFrom(this.translate.get('pleaseSelectValidDates')); 
        customToastr(pleaseSelectValidDatesTranslation, 'error');
        return;
      }
      let _termDetails = {termName:termDetails.termName,startDate:stDate,endDate:edDate,academicId:this.selectedAcademic.pkAcademicId};
      this.financialTermProcessing = true;
      this.academicService.createFinancialTerm(_termDetails).subscribe(
        async (data: any) => {
          this.financialTermProcessing = false;
          if (data.errorcode) {
            const failedToCreateFinancialTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateFinancialTermPleaseTryAgain')); 
            customToastr(failedToCreateFinancialTermPleaseTryAgainTranslation, 'error');
          }
          else if(data.message == 'AlreadyExist'){
            const financialTermAlreadyExistsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('financialTermAlreadyExistsPleaseTryAgain')); 
            customToastr(financialTermAlreadyExistsPleaseTryAgainTranslation, 'error');
          }
          else{
            this.clearCreateFinanceTermForm();
            const successfullyFinancialTermCreatedTranslation = await firstValueFrom(this.translate.get('successfullyFinancialTermCreated')); 
            customToastr(successfullyFinancialTermCreatedTranslation, 'success');
            setTimeout(function () {
              $("#close-create-financial-term").trigger('click')
            },3000)
          }
        },
        async error => {
          this.financialTermProcessing = false;
          const failedToCreateFinancialTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToCreateFinancialTermPleaseTryAgain')); 
          customToastr(failedToCreateFinancialTermPleaseTryAgainTranslation, 'error');
          }
      );
    }
    else{
      const pleaseProvideAllDetailsTranslation = await firstValueFrom(this.translate.get('pleaseProvideAllDetails')); customToastr(pleaseProvideAllDetailsTranslation, 'error');
    }
  }

  clearCreateFinanceTermForm(){
    this.createFinancialTerm = {termName:null,startDate:'',endDate:''};
    $("#duedateDatePicker1").val('');
    $("#duedateDatePicker2").val('');
  }

  deleteFinancialTermOpen(fTerm){
    this.selectedFinancialTerm = fTerm;
  }

  deleteFinancialTerm(){
    this.financialTermProcessing = true;
    this.academicService.deleteFinancialTerm(this.selectedFinancialTerm.pkFinancialTermId,this.selectedAcademic.pkAcademicId).subscribe(
      async (data: any) => {
        this.financialTermProcessing = false;
        if (data.errorcode) {
            const failedToDeleteFinancialTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteFinancialTermPleaseTryAgain')); 
            customToastr(failedToDeleteFinancialTermPleaseTryAgainTranslation, 'error');
        }
        else {
          const financialTermSuccessfullyDeletedTranslation = await firstValueFrom(this.translate.get('financialTermSuccessfullyDeleted')); 
          customToastr(financialTermSuccessfullyDeletedTranslation, 'success');
          setTimeout(function () {
            $("#close-delete-financial-term").trigger('click');
          },3000)
        }
      },
      async error => {
        this.financialTermProcessing = false;
        const failedToDeleteFinancialTermPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToDeleteFinancialTermPleaseTryAgain')); 
        customToastr(failedToDeleteFinancialTermPleaseTryAgainTranslation, 'error');
      }
    );
  }

  getClassStandardsOfSchool() {
    this.classSections = [];
    this.academicService.getAvailableClass()   .subscribe(
      (data: any) => {
        if (data.errorcode) {

        }
        else {
          this.classStandards = data.schoolStandards;
        }
      },
      error =>
      () => {

      }
    );
  }


  getClassSections(id) {
    this.academicService.getClassSections(id)   .subscribe(
      (data: any) => {
        if (data.errorcode) {

        }
        else {
          this.classSections = data[0];
        }
      },
      error =>
      () => {

      }
    );
  }

  getStudents(standardClassId, sectionId, status, academicId) {

    this.academicService.getClassStudents(standardClassId, sectionId, status, academicId)
      .subscribe(
        async (data: any) => {
          if (data.errorcode) {
            const failedToFetchStudentsPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToFetchStudentsPleaseTryAgain')); 
            customToastr(failedToFetchStudentsPleaseTryAgainTranslation, 'error');
          }
          else {
            this.students = data;
            var rows = [];
            this.students.forEach(function(stu,index){
              var dateText = "";
              var active = "Active";
              if(stu.DateOfBirth && stu.DateOfBirth !="null" && stu.DateOfBirth !="0000-00-00"){
                var date = new Date(stu.DateOfBirth);
                dateText = ""+date.getDate()+"-"+date.getMonth()+"-"+date.getFullYear();
              }
              if(!stu.isAppUser){
                active = '<p style="background: #dadada;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">Active</p>'
              }
              else{
                active = '<p style="background: #9E9E9E;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">Active</p>'
              }
              rows.push([index+1,stu.studentName,stu.parentName,stu.mobileNumber,dateText,active])
            });
            this.studentDataTable.clear().draw();
            this.studentDataTable.rows.add(rows).draw();
          }

        },
        error =>
        () => {

        }
      );
  }

  applyAcademicListTable() {
  this.translate.get([
    'dataTables.sEmptyTable',
    'dataTables.lengthMenu',
    'dataTables.search',
    'dataTables.paginate.previous',
    'dataTables.paginate.next',
    'dataTables.info',
    'dataTables.infoEmpty',
    'dataTables.infoFiltered',
    'dataTables.zeroRecords',
    'dataTables.loadingRecords',
    'dataTables.processing',
  ]).subscribe(translations => {

    $('#academics_list_table').DataTable({
      "dom": 'lCfrtip',
      "order": [],
      "colVis": {
        "buttonText": "Columns",
        "overlayFade": 0,
        "align": "right"
      },
      "language": {
        "lengthMenu": translations['dataTables.lengthMenu'],
        "search": `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
        "emptyTable": translations['dataTables.sEmptyTable'],
        "zeroRecords": translations['dataTables.zeroRecords'],
        "info": translations['dataTables.info'],
        "infoEmpty": translations['dataTables.infoEmpty'],
        "infoFiltered": translations['dataTables.infoFiltered'],
        "loadingRecords": translations['dataTables.loadingRecords'],
        "processing": translations['dataTables.processing'],
        "paginate": {
          "previous": `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
          "next": `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`
        }
      }
    });

  });
}


 applyDataTable() {
  if (this.studentDataTable == null) {
    this.translate.get([
      'dataTables.sEmptyTable',
      'dataTables.lengthMenu',
      'dataTables.search',
      'dataTables.paginate.previous',
      'dataTables.paginate.next',
      'dataTables.info',
      'dataTables.infoEmpty',
      'dataTables.infoFiltered',
      'dataTables.zeroRecords',
      'dataTables.loadingRecords',
      'dataTables.processing',
    ]).subscribe(translations => {

      this.studentDataTable = $('#datatableSlideStudents').DataTable({
        "dom": 'lCfrtip',
        "order": [],
        "colVis": {
          "buttonText": "Columns",
          "overlayFade": 0,
          "align": "right"
        },
        "language": {
          "lengthMenu": translations['dataTables.lengthMenu'],
          "search": `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
          "emptyTable": translations['dataTables.sEmptyTable'],
          "zeroRecords": translations['dataTables.zeroRecords'],
          "info": translations['dataTables.info'],
          "infoEmpty": translations['dataTables.infoEmpty'],
          "infoFiltered": translations['dataTables.infoFiltered'],
          "loadingRecords": translations['dataTables.loadingRecords'],
          "processing": translations['dataTables.processing'],
          "paginate": {
            "previous": `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
            "next": `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`
          }
        }
      });

    });
  }
}
  selectedAcademicStartDate = "";
  selectedAcademicEndDate = "";
  creatingAcademicYear = false;

  async createAcademic(){
    try{
      if(this.selectedAcademicStartDate==""){
           this.messageService.add({
          key: 'global',
          severity: 'error',
          summary:  this.translate.instant('errorForToast'),
          detail: this.translate.instant('addAcademicStartDate') 
        });
        return;
      }
      if(this.selectedAcademicEndDate==""){
           this.messageService.add({
          key: 'global',
          severity: 'error',
          summary:  this.translate.instant('errorForToast'),
          detail: this.translate.instant('addAcademicEndDate') 
        });
        return;
      }
      this.creatingAcademicYear = true;
      const body = {
      startDate : this.selectedAcademicStartDate ? moment(this.selectedAcademicStartDate).format('YYYY-MM-DD') : null,
      endDate : this.selectedAcademicEndDate ? moment(this.selectedAcademicEndDate).format('YYYY-MM-DD') : null,
      includeLateFeeInTransportFee : this.includeLateFeeInTransport,
      inActive : 1
    }
    const response :any= await firstValueFrom(this.academicService.createNewAcademic(body));
     if(response.status){
      this.messageService.add({
          key: 'global',
          severity: 'success',
          summary: this.translate.instant('success'),
          detail: this.translate.instant('academicCreatedSuccessfully')
        });
        this.selectedAcademicStartDate="";
        this.selectedAcademicEndDate="";
        this.getAcademicList();
        $("#close_add_academic_popup").trigger("click");
     }else{
      this.messageService.add({
          key: 'global',
          severity: 'error',
          summary: this.translate.instant('errorForToast'),
          detail: this.translate.instant('failedToCreatedAcademicYear')
        });
     }
       this.creatingAcademicYear = false;
    }
    catch(error){
      this.creatingAcademicYear = false;
      this.messageService.add({
          key: 'global',
          severity: 'error',
          summary: this.translate.instant('error'),
          detail: this.translate.instant('failedToCreatedAcademicYear')
        });
    }
  }


  

  /* promote students */
  promoteStudentsFirstStep(){
    $("#promote_student_next").addClass("disabled");
    $("#promote_student_finish").addClass("hide");
    $("#rootwizard1").find(".progress").css({width:'80%'});
    $("#rootwizard1").find(".progress-bar").css({width:'0%'});
    var step = $("#promote_students_wizard").find(".active").find(".step").text();
    if(step == 1){
      $("#rootwizard1").find(".progress-bar").css({width:'0%'});
    }
    else if(step == 2){
      $("#rootwizard1").find(".progress-bar").css({width:'35%'});
    }
    else if(step == 3){
      $("#rootwizard1").find(".progress-bar").css({width:'65%'});
    }
    else if(step == 4){
      $("#rootwizard1").find(".progress-bar").css({width:'95%'});
    }

    this.academicService.getCurrentAndNextAcademic()
      .subscribe(
        (data: any) => {
          if (data.errorcode) {

          }
          else {
            this.currentAcademic = data.academic;
            this.nextAcademic = data.nextAcademic;
            if(!this.nextAcademic){
              $("#promote_student_next").addClass("disabled");
            }
            else{
              $("#promote_student_next").removeClass("disabled");
            }
          }
        },
        error =>
        () => {

        }
      );
  }

  openCreateAcademic(){
    $('#create_new_academic').trigger('click');
  }

  openCreateAcademicsPopup(fromPromoteStudent){
    $("#startDate_add").datepicker({autoclose:true});
    $("#endDate_add").datepicker({autoclose:true});
    $("#startDate_add").val("");
    $("#endDate_add").val("");
    $('#isCurentAcademic').attr('checked', false);
    this.fromPromoteStudent = fromPromoteStudent;
  }

  async promoteStudentNext(){
    var step = $("#promote_students_wizard").find(".active").find(".step").text();

    if(step == 1){
      $("#rootwizard1").find(".progress-bar").css({width:'35%'});
      $("#rootwizard1").find(".active").addClass('done');
      $("#rootwizard1").find(".active").removeClass('active');
      $("#rootwizard1").find("#step2").trigger('click');

      $("#promote_student_next").find('a').text("Process Transition");
      const fetchingClassListPlsWaitTranslation = await firstValueFrom(this.translate.get('fetchingClassListPlsWait')); 
      customToastr(fetchingClassListPlsWaitTranslation, 'success');
      this.getNextClassOfClass();
      this.applyPromoteStudentsTable();

    }
    else if(step == 2){
      $("#rootwizard1").find(".progress-bar").css({width:'65%'});
      $("#rootwizard1").find(".active").addClass('done');
      $("#rootwizard1").find(".active").removeClass('active');
      $("#rootwizard1").find("#step6").trigger('click');
    }
    else if(step == 3){
      $("#rootwizard1").find(".progress-bar").css({width:'80%'});
      $("#rootwizard1").find(".active").addClass('done');
      $("#rootwizard1").find(".active").removeClass('active');
      $("#rootwizard1").find("#step7").trigger('click');
      this.processAcademicPromotion();
    }
    else if(step == 4){
      $(".modal-backdrop").model('hide');
    }
  }

  async processAcademicPromotion(){
    $("#promote_student_finish").find('a').text("Finish");
    this.statusMessage = await firstValueFrom(this.translate.get('pleaseWaitAcademicTransitionIsInProgress')); 
    customToastr(this.statusMessage,'success')
    $("#promote_student_prev").hide()
    $("#promote_student_next").hide();
    $("#promote_student_finish").addClass("show");
    $("#promote_student_finish").addClass("disabled");
    $("#loading_academic_transition").addClass("show");
    $("#loading_academic_transition").removeClass("hide");
    var obj = {
      currentAcademic:this.currentAcademic.pkAcademicId,
      nextAcademic:this.nextAcademic.pkAcademicId,
      reason:'Academic completed',
      classTimetableClearInfo:[],
      feeStructureRemain:false
    };

    this.academicService.processPromoteStudent(obj)
      .subscribe(
        async (data: any) => {
          if (!data.status) {
            const academicTransitionFailedPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('academicTransitionFailedPleaseTryAgain')); 
            customToastr(academicTransitionFailedPleaseTryAgainTranslation, 'error');
            $("#promote_student_finish").removeClass("disabled");
            $("#promote_student_finish").find('a').text("Retry");
            $("#loading_academic_transition").addClass("hide");
            $("#loading_academic_transition").removeClass("show");
            this.statusMessage = await firstValueFrom(this.translate.get('academicTransitionFailedPlsTryAgain')); 
          }
          else {
            this.statusMessage = await firstValueFrom(this.translate.get('academicPromotionSuccessfullyDone')); 
            customToastr(this.statusMessage,'success');
            this.getAcademicTransitionResult();
          }
        },
        error =>
        () => {

        }
      );
  }

  promoteStudentPrev(){
    var step = $("#promote_students_wizard").find(".active").find(".step").text();
    if(step == 2){
      $("#promote_student_next").find("a").text("Next");
    }
  }

  async getNextClassOfClass(){
    $("#generating_promotion_list").addClass("show")
    $("#generating_promotion_list").removeClass("hide")

    this.generatePromotionListMessage = await firstValueFrom(this.translate.get('pleaseWaitWeAreGeneratingStudentPromotionListForReview')); 
    customToastr(this.generatePromotionListMessage,'success');
    this.academicService.getNextClassOfClass()
      .subscribe(
        async (data: any) => {
          if (data.errorcode || !data.status) {
            $("#promote_student_next").show()
            $("#promote_student_next").find("a").text("Next");
            this.generatePromotionListMessage = "Classes order is not proper";
            const failedToGeneratePromotionListClassesOrderIsNotProperTranslation = await firstValueFrom(this.translate.get('failedToGeneratePromotionListClassesOrderIsNotProper')); 
            customToastr(failedToGeneratePromotionListClassesOrderIsNotProperTranslation, 'error');
            $("#rootwizard1").find(".progress-bar").css({width:'0%'});
            $("#rootwizard1").find(".active").removeClass('active');
            $("#step1").trigger('click');

            //this.promoteStudentPrev();
          }
          else {
            $("#generating_promotion_list").addClass("hide")
            $("#generating_promotion_list").removeClass("show")
            $("#promote_student_next").show()

            this.nextClassOfClass = data.classes;
            var h = this;
            setTimeout(function(){
              $("#select_promoting_class").val(h.nextClassOfClass[0].fkClassId);
              h.fetchStudentPromotionList();
            },100);

            const pleaseSelectAClassToShowPromotingStudentsListTranslation = await firstValueFrom(this.translate.get('pleaseSelectAClassToShowPromotingStudentsList')); 
            customToastr(pleaseSelectAClassToShowPromotingStudentsListTranslation, 'success');
          }
        },
        error =>
        () => {

        }
      );
  }

  fetchStudentPromotionList(){
    var classId = $("#select_promoting_class").val();

    this.studentPromotionListTable.clear().draw();
    this.academicService.getPromotionListByClass(classId)
      .subscribe(
        (data: any) => {
          if (data.errorcode || !data.status) {

          }
          else {

            var select = "<select id='change_promote_class_of_student' name='change_promote_class_of_student'  style='text-decoration: none;color:grey;font-size:12px'>";
            this.nextClassOfClass.forEach(function(it){
              var a = $("<option value='"+it.fkClassId+"'></option>");
              a.text(it.classNumber+" - "+it.classDivision);
              select += a[0].outerHTML;
            });
            select += "<option value='END'>END</option></select>";

            if(data.list && data.list.length > 0){
              var rows = [];
              data = data.list;
              for(var i=0;i<data.length;i++){
                var html = $(select);
                html.attr("info",JSON.stringify(data[i]));
                html.val(data[i].toClassId);
                rows.push([i+1,data[i].studentName,data[i].parentName,data[i].fromClassNumber+" - "+data[i].fromClassDivision,html[0].outerHTML])
              }
              this.studentPromotionListTable.rows.add(rows).draw();
            }
            else{
              this.studentPromotionListTable.clear().draw();
            }
          }
        },
        error =>
        () => {

        }
      );
  }

  applyPromoteStudentsTable() {
    if (this.studentPromotionListTable == null) {
      this.translate.get([
        'dataTables.emptyTable',
        'dataTables.lengthMenu',
        'dataTables.search',
        'dataTables.paginate.previous',
        'dataTables.paginate.next',
        'dataTables.info',
        'dataTables.infoEmpty',
        'dataTables.infoFiltered',
        'dataTables.zeroRecords',
        'dataTables.buttons.colvis' // used for "Columns"
      ]).subscribe(translations => {
        this.studentPromotionListTable = $('#student_promotionList_table').DataTable({
          dom: 'lCfrtip',
          order: [],
          colVis: {
            buttonText: translations['dataTables.buttons.colvis'],
            overlayFade: 0,
            align: "right"
          },
          language: {
            emptyTable: translations['dataTables.emptyTable'],
            lengthMenu: translations['dataTables.lengthMenu'],
            search: `<i class="fa fa-search"></i> ${translations['dataTables.search']}`,
            paginate: {
              previous: `<i class="fa fa-angle-left"></i> ${translations['dataTables.paginate.previous']}`,
              next: `${translations['dataTables.paginate.next']} <i class="fa fa-angle-right"></i>`
            },
            info: translations['dataTables.info'],
            infoEmpty: translations['dataTables.infoEmpty'],
            infoFiltered: translations['dataTables.infoFiltered'],
            zeroRecords: translations['dataTables.zeroRecords']
          },
          rowCallback: function (row, data, index) {
            var info = $(row).find("#change_promote_class_of_student").attr("info");
            info = JSON.parse(info);
            $(row).find("#change_promote_class_of_student").val(info.toClassId || 'END');
          }
        });

        var h = this;
        $("#student_promotionList_table tbody").on("change", "#change_promote_class_of_student", function () {
          var info = $(this).val();
          var id = JSON.parse($(this).attr("info")).idSchoolNextAcademicPromotionList;
          if (info == "END") {
            info = null;
          }
          h.updateStudentPromote(info, id);
        });
      });
    }
  }



  updateStudentPromote(toClassId, promoteId) {
    this.academicService.updateStudentPromotionList(toClassId, promoteId)
      .subscribe(
        async (data: any) => {
          if (!data.status) {
            customToastr(data.message, 'error')
          }
          else {
            const studentPromotingClassSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('studentPromotingClassSuccessfullyUpdated'));
            customToastr(studentPromotingClassSuccessfullyUpdatedTranslation, 'success');
          }
        },
        error =>
          () => {
          }
      );
  }

  getAcademicTransitionResult(){
    this.academicService.promoteStudentResult()
      .subscribe(
        async (data: any) => {
          if (!data.status) {
            const failedToFetchAcademicTransitionResultsTranslation = await firstValueFrom(this.translate.get('failedToFetchAcademicTransitionResults')); 
            customToastr(failedToFetchAcademicTransitionResultsTranslation, 'error');
          }
          else {
            $("#loading_academic_transition").addClass("hide");
            $("#loading_academic_transition").removeClass("show");
            this.statusMessage = "Final Report";
            this.academicTransitionResults = data.info[0];
            $("#promote_student_finish").removeClass("disabled");
          }

        },
        error => {
        }
      );
  }

  promoteStudentFinish(){
    if($("#promote_student_finish").find('a').text() == "Retry"){
      this.processAcademicPromotion();
    }
    else{
      $("#close-promote-popup").trigger("click");
      this.loaded = false;
      this.getAcademicList();
    }

  }

  // function for toggle button
  onIncludeLateFeeChange(checked : boolean){
    this.includeLateFeeInTransport = checked;
  }


  // function to open warning late fees
  openWarningForLateFees(data){
    this.transportApplyLateFeesAcademicId = data;    
  }

  // function to close pop up for warning apply late fees
  closeWarningForLateFees() {
  this.academicList = this.academicList.map(item => {
    if (item.pkAcademicId === this.transportApplyLateFeesAcademicId.pkAcademicId) {
      return {
        ...item,
        includeLateFeeInTransportFee: !item.includeLateFeeInTransportFee
      };
    }
    return item;
  });
  this.transportApplyLateFeesAcademicId = null;
}


  // api call for update late fee in transport academic
  async updateLateFeesInTransportInAcademic(){
    try{
      this.updatingAcademicYear = true;
      const body ={
        lang : "en",
        academicId : this.transportApplyLateFeesAcademicId.pkAcademicId,
        includeLateFeeInTransportFee: this.transportApplyLateFeesAcademicId.includeLateFeeInTransportFee
      }
      const response :any= await firstValueFrom(this.academicService.changeIncludeTermFee(body));
      if(response && response.body){
          this.messageService.add({
          key: 'global',
          severity: 'success',
          summary:  "Success",
          detail: response.body.message 
        });
        this.transportApplyLateFeesAcademicId=null
      }
      this.updatingAcademicYear = false;

    }
    catch(error){
          this.updatingAcademicYear = false;
          this.messageService.add({
          key: 'global',
          severity: 'error',
          summary:  "error",
          detail: error.error.message 
        });
    }
  }
}